<template>
  <loader v-if="loader" />
  <div v-else class="set-mimk">
    <h2 class="set-mimk__title">
      {{ $t("mc.supervisor.titles.setM1OnMc") }}
    </h2>
    <input
      class="input-text set-mimk__input"
      type="text"
      :placeholder="$t('mc.placeholders.search')"
      v-model="searchedM1"
      :disabled="!m1List.length && !searchedM1.length"
    />
    <perfect-scrollbar v-if="m1List.length">
      <div
        class="set-mimk__choise"
        v-for="element in m1List"
        :key="element.id"
      >
          <div style="display: flex">
            <div class="set-mimk__person" @click="choiseM1(element)">
            <span
                :class="[{ 'mimk-active': element.active }, 'set-mimk__text']"
            >{{ element.label }}</span
            >
              <div>
                <inline-svg
                    v-if="element.active"
                    :src="require(`@/assets/svg/check.svg`)"
                />
              </div>
            </div>
            <div class="set-mimk__status flex">
              <div
                  class="status-square"
                  :style="{ background: statusColor(element.status) }"
              ></div>
              {{ $t(element.title) }}
            </div>
          </div>
        </div>
    </perfect-scrollbar>
    <div
      class="empty-mk-title empty-mimk"
      v-if="!m1List.length && !searchedM1.length"
    >
      {{ $t("mc.supervisor.titles.noMimk") }}
    </div>
    <div
      class="empty-mk-title empty-mimk"
      v-if="!m1List.length && searchedM1.length"
    >
      {{ $t("mc.supervisor.titles.mimksNotFound") }}
    </div>
    <div class="set-mimk__buttons flex">
      <button
        class="btn btn_blue"
        :disabled="disableButton"
        @click="appointM1"
      >
        <span v-if="isAppoint">{{ $t("mc.supervisor.buttons.addMimk") }}</span>
        <span v-else>{{ $t("mc.supervisor.buttons.saveChanges") }}</span>
      </button>
      <button
        @click="clearActiveFields"
        :disabled="disableButton"
        class="btn btn_transparent btn-cancel"
      >
        {{ $t("mc.supervisor.buttons.cancel") }}
      </button>
    </div>
    <div class="set-mimk_status-time flex">
      <inline-svg
        class="info-svg"
        :src="require(`@/assets/svg/info.svg`)"
      />
      <div>{{ $t("mc.supervisor.statusMimk.statusByTcTime") }}: {{tcDate}}</div>
    </div>
  </div>
</template>

<script>
import apiBooking from "@/api/master-classes/booking";
import apiM1 from "@/api/master-classes/m1";
import { statusColor } from "@/helpers/changeStatuses";
export default {
  data() {
    return {
      tcDate: "",
      searchedM1: "",
      disableButton: true,
      selectedM1: "",
      statusColor,
      listOfM1: [],
      loader: true,
    };
  },
  props: {
    MasterClass: {
      type: Object,
      required: true,
    },
    isAppoint: {
      type: Boolean,
      required: true,
    },
    isConfirm: {
      type: Boolean,
      required: false,
    }
  },
  async created() {
    this.tcDate = this.date
    console.log(this.tcDate)
    const listM1 = await apiM1.getM1Status(
      this.tcDate
    );
    this.$store.commit("user/setM1List", listM1);

    this.listOfM1 = this.$store.state.user.m1List;
    this.listOfM1.forEach((el) => {
      for (const matchedElement in this.$store.state.statuses.m1Statuses) {
        if (
          el.status ===
          this.$store.state.statuses.m1Statuses[matchedElement].statusMatch
        ) {
          el.title =
            this.$store.state.statuses.m1Statuses[
              matchedElement
            ].translateStatusTitle;
        }
      }
    });
    this.loader = false;
  },
  computed: {
    date() {
      if (this.MasterClass.date) {
        if (this.isConfirm) {
          const { date, time } = this.MasterClass.date;
          const formattedDate = this.$dayjs(date, 'DD.MM.YYYY').format('YYYY-MM-DD');
          return `${formattedDate} ${time}`;
        } else {
          const { hour, start } = this.MasterClass.date;
          const formattedStart = this.$dayjs(start, 'DD.MM.YYYY').format('YYYY-MM-DD');
          return `${formattedStart} ${hour}`;
        }
      } else {
        return this.MasterClass.created_at;
      }
    },
    mcId() {
      if (this.isConfirm) {
        return this.MasterClass.id
      } else {
        return this.MasterClass.mcId
      }
    },
    m1List() {
      let object = this.listOfM1.filter((element) => {
        return (
          element.label
            .toLowerCase()
            .trim()
            .indexOf(this.searchedM1.toLowerCase().trim()) != -1
        );
      });
      return object;
    },
  },
  methods: {
    //Убираем класс активности у всех мимков
    removeCheckM1() {
      this.m1List.forEach((element) => {
        if (element.active) {
          element.active = false;
        }
      });
    },
    //Отправляем запрос и изменяем рабочего МИМКа на МК
    async appointM1() {
      await apiBooking.updateBooking(
        this.mcId,
        this.selectedM1,
        true
      );
      this.$emit("closeModal", true);
    },
    clearActiveFields() {
      this.disableButton = true;
      this.removeCheckM1();
    },
    //При выборе МИМКа
    choiseM1(m1) {
      this.clearActiveFields();
      this.selectedM1 = {
        m1_confirmation: m1.id,
        m1_confirmation_name: m1.label,
      };
      m1.active = true;
      this.disableButton = false;
      if (this.MasterClass.m1 === m1.label) {
        this.disableButton = true;
        m1.active = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.buzy-mimk {
  pointer-events: none;
  cursor: default;
  text-decoration: none;
  opacity: 0.5;
}
.empty-mimk {
  margin: 0;
  height: 340px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.ps {
  height: 340px;
}
.mimk-active {
  color: #315af2;
}
.status-square {
  width: 18px;
  height: 18px;
  margin-right: 8px;
}
.btn-cancel {
  margin-left: 20px;
  min-width: 148px;
  max-width: 148px;
}
.set-mimk {
  &__choise {
    display: flex;
    margin-bottom: 18px;
    flex-direction: column;
    &:last-child {
      margin-bottom: 0;
    }
  }
  &__person {
    cursor: pointer;
    display: flex;
    width: 200px;
    margin-right: 20px;
  }
  &__text {
    margin-right: 20px;
    font-weight: 400;
  }
  &__input {
    margin-bottom: 18px;
  }
  &__buttons {
    margin-top: 45px;
  }
  &__title {
    margin-bottom: 45px;
  }
  &_status-time {
    padding: 10px;
    background-color: rgb(222, 235, 255);
    margin-top: 30px;
  }
}
.info-svg {
  margin: 0 5px 0 0;
  width: 24px;
}
</style>
